import { render, staticRenderFns } from "./ExportPayrollModal.vue?vue&type=template&id=3f8a0f04&scoped=true&lang=pug"
import script from "./ExportPayrollModal.vue?vue&type=script&lang=js"
export * from "./ExportPayrollModal.vue?vue&type=script&lang=js"
import style0 from "./ExportPayrollModal.vue?vue&type=style&index=0&id=3f8a0f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a0f04",
  null
  
)

export default component.exports